import Vue from 'vue'
import VueRouter from 'vue-router'

import NProgress from 'nprogress'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)

}

const routes = [
/*   {
    path: '/',
    name: 'index',
    component: () => import('@/views/Index'),
    meta: {
      title: '源计划建筑设计（广州）有限公司'
    }
  }, */
  {
    path: '/',//home
    name: 'home',
    component: () => import('@/views/Home'),
    meta: {
      title: '源计划建筑设计（广州）有限公司'
    }
  }, 

  {
    path: '/project/list/:id',
    name: 'list',
    component: () => import('@/views/Project/Index'),
    meta: {
      title: '项目'
    }
  },  

  {
    path: '/project/detail/:id',
    name: 'homedetail',
    component: () => import('@/views/Home'),
    meta: {
      title: '项目详情页'
    }
  },

 /*  {
    path: '/menu/:id',
    name: 'menu',
    component: () => import('@/views/Menu'),
    meta: {
      title: '菜单栏'
    }
  },
   */
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/About'),
    meta: {
      title: '关于工作室'
    }
  },

 
  {
    path: '/search',
    name: 'search',
    component: () => import('@/views/Search'),
    meta: {
      title: '搜索'
    }
  },
 /*  {
    path: '/project/detail/:id',
    name: 'detail',
    component: () => import('@/views/Project/Detail'),
    meta: {
      title: '项目详情页'
    }
  } */
]
const router = new VueRouter({
  mode: "history",
  scrollBehavior: () => ({y: 0}),
  routes
})
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})


router.afterEach(() => {
  setTimeout(() => {
      NProgress.done();
  }, 150);
});

export default router
